'use client';

import { useTranslations } from 'next-intl';
import { Box } from '@terra/ui-styled-system';
import { BodyDefault, ListPageHeader } from '@terra/ui-design-system';
import { isAppTarget, TARGET_TYPE } from '../../../utils/target-scope.utils';
import { useTargetId, useTargetType } from '../../../store/projectStore';
import { ExternalNetworkAssetsList } from './ExternalNetworkAssetsList';
import { InternalNetworkAssetsList } from './InternalNetworkAssetsList';

export function ExternalNetworkAssetsContent() {
  const targetId = useTargetId();
  const targetType = useTargetType();
  const t = useTranslations('proxy.assets.page');

  if (!targetId) {
    return (
      <Box
        h="full"
        w="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <BodyDefault color="fg.muted">{t('selectTarget')}</BodyDefault>
      </Box>
    );
  }

  if (isAppTarget(targetType)) {
    return null;
  }

  if (targetType === TARGET_TYPE.EXTERNAL_NETWORK) {
    return (
      <ExternalNetworkAssetsList
        surfaceId={targetId}
        header={
          <ListPageHeader
            title={t('title')}
            subtitle={t('externalNetworkSubtitle')}
          />
        }
      />
    );
  }

  if (targetType === TARGET_TYPE.INTERNAL_NETWORK) {
    return (
      <InternalNetworkAssetsList
        networkId={targetId}
        header={
          <ListPageHeader
            title={t('title')}
            subtitle={t('internalNetworkSubtitle')}
          />
        }
      />
    );
  }

  return (
    <Box
      h="full"
      w="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <BodyDefault color="fg.muted">{t('unavailableForTarget')}</BodyDefault>
    </Box>
  );
}
